module.exports = __webpack_public_path__ + "gr.5832972d460d58e4c46d.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/gr.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/gr.svg
// module chunks = styles